
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexdbgzvN1efdLFSqI8oLN9Xus7oCDQ8dzI163ALg8gWJAMeta } from "/app/apps/ags/pages/index.vue?macro=true";
import { default as _91slug_93Sy_Q9HAZmykVIsaM4XBiKfFL5BbhArx_TcidNnY4O7kMeta } from "/app/apps/ags/pages/account/goldner-club/[slug].vue?macro=true";
import { default as index9EdcBJDRCIH0SFtz8DGhvhPik_kBPMA8J5Ph5iyWyWEMeta } from "/app/apps/ags/pages/account/goldner-club/index.vue?macro=true";
import { default as _91id_939jYdp_xLhY_reztBcR3qpsWXXQjD_vhTN04oKURkiMgMeta } from "/app/apps/ags/pages/account/orders/[id].vue?macro=true";
import { default as ordersl_GnqUJdAUltCfZ_VEfvEGii9CeGQJva_3hmVbuLRhoMeta } from "/app/layers/base/pages/account/orders.vue?macro=true";
import { default as indexKaVL1h9bonjwaeLvNToDBFm1KffgBU0BihTvtcoy7LcMeta } from "/app/apps/ags/pages/account/user/index.vue?macro=true";
import { default as resetF3FXgIq9dmSGzcU0z56hHVtgd0Skqc8xyJOaRI6F8QAMeta } from "/app/layers/base/pages/password/reset.vue?macro=true";
import { default as direct_45orderg1beYY1rNJglP1s0CjWb6KZfuYc4xVmkFvgHJwasu4IMeta } from "/app/apps/ags/pages/service/direct-order.vue?macro=true";
import { default as _91id_93IUhiTzouVMkZlHDIJaUChxIRNk1ce1yi3IpFZ_Lnb0IMeta } from "/app/apps/ags/pages/p/[slug]/[id].vue?macro=true";
import { default as _91slug_939xVhHkLMmVk_CFfrPzQlOhhknDckMH4QemUEBByuwUsMeta } from "/app/apps/ags/pages/magazine/[slug].vue?macro=true";
import { default as indexOkr3k94Mnnw0me0PQYyt15kK7ioZzAbj5Z8FV3LX2CIMeta } from "/app/apps/ags/pages/outfits/[slug]/index.vue?macro=true";
import { default as _91_46_46_46slug_93tgNZI1oo6suJ2uFMuxbIVv0_ZISFrlYnnUrOycf0ewwMeta } from "/app/apps/ags/pages/c/[...slug].vue?macro=true";
import { default as indexQlCtmYL7wBCvlSN95FL5dykt_pUUcjys3pMSl92ABTEMeta } from "/app/apps/ags/pages/account/index.vue?macro=true";
import { default as basketbSeLQ73G9IkL_0Dc1VcSNdyU8pzRNl2aw1KK1IR_fOUMeta } from "/app/apps/ags/pages/basket.vue?macro=true";
import { default as checkout7RWXJwXJ0p_Cyroz15Py0wiOKlVRA4nsmR9izWTRey8Meta } from "/app/apps/ags/pages/checkout.vue?macro=true";
import { default as checkout_external_basketMt4mJpjEkg33UW4shRkiLiGrf_JGosO1DQQ14alg1h4Meta } from "/app/apps/ags/pages/checkout_external_basket.vue?macro=true";
import { default as indexoW5Oj6WwicnJf19YMh5LGbn4f2sMGoAu9EXk6UkxlbkMeta } from "/app/apps/ags/pages/magazine/index.vue?macro=true";
import { default as indexPh8_GpyGxBpPb6lON_y8kQNZqfbBVragPLcB9c_A0pcMeta } from "/app/apps/ags/pages/outfits/index.vue?macro=true";
import { default as releasetestpageOi6JLRiRXwr4Sc2sYhGwhn9oXn__0xmEQLMDKOtuJCoMeta } from "/app/layers/base/pages/releasetestpage.vue?macro=true";
import { default as searchgrDs2z36YLi1H_UfcBJ0py0MIwamnbKvG_ADCvWVutEMeta } from "/app/layers/base/pages/search.vue?macro=true";
import { default as signinEtLygm6Rb3c1bkLo7W4ewpawO3u73UUXxI3mvwQPxGgMeta } from "/app/apps/ags/pages/signin.vue?macro=true";
import { default as success7jqWc3oqAw0_5XjEfcI71MDbnriAcexCcDpEp1NOJI4Meta } from "/app/apps/ags/pages/success.vue?macro=true";
import { default as wishlistSzfUTnu0k4MxcGTI4J3d_arVQSssnNQiMz6RmapZBmgMeta } from "/app/apps/ags/pages/wishlist.vue?macro=true";
import { default as _91_46_46_46slug_93mMk1vWJ1XP6Z0IPjaNqnTvt6VhMchCi5GqoSNwXnZboMeta } from "/app/layers/base/pages/[...slug].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexdbgzvN1efdLFSqI8oLN9Xus7oCDQ8dzI163ALg8gWJAMeta || {},
    component: () => import("/app/apps/ags/pages/index.vue")
  },
  {
    name: "account-goldner-club-slug___at",
    path: "/at/account/goldner-club/:slug()",
    meta: _91slug_93Sy_Q9HAZmykVIsaM4XBiKfFL5BbhArx_TcidNnY4O7kMeta || {},
    component: () => import("/app/apps/ags/pages/account/goldner-club/[slug].vue")
  },
  {
    name: "account-goldner-club-slug___be",
    path: "/be/account/goldner-club/:slug()",
    meta: _91slug_93Sy_Q9HAZmykVIsaM4XBiKfFL5BbhArx_TcidNnY4O7kMeta || {},
    component: () => import("/app/apps/ags/pages/account/goldner-club/[slug].vue")
  },
  {
    name: "account-goldner-club-slug___fr-be",
    path: "/fr-be/account/goldner-club/:slug()",
    meta: _91slug_93Sy_Q9HAZmykVIsaM4XBiKfFL5BbhArx_TcidNnY4O7kMeta || {},
    component: () => import("/app/apps/ags/pages/account/goldner-club/[slug].vue")
  },
  {
    name: "account-goldner-club-slug___ch",
    path: "/ch/account/goldner-club/:slug()",
    meta: _91slug_93Sy_Q9HAZmykVIsaM4XBiKfFL5BbhArx_TcidNnY4O7kMeta || {},
    component: () => import("/app/apps/ags/pages/account/goldner-club/[slug].vue")
  },
  {
    name: "account-goldner-club-slug___fr-ch",
    path: "/fr-ch/account/goldner-club/:slug()",
    meta: _91slug_93Sy_Q9HAZmykVIsaM4XBiKfFL5BbhArx_TcidNnY4O7kMeta || {},
    component: () => import("/app/apps/ags/pages/account/goldner-club/[slug].vue")
  },
  {
    name: "account-goldner-club-slug___de",
    path: "/de/account/goldner-club/:slug()",
    meta: _91slug_93Sy_Q9HAZmykVIsaM4XBiKfFL5BbhArx_TcidNnY4O7kMeta || {},
    component: () => import("/app/apps/ags/pages/account/goldner-club/[slug].vue")
  },
  {
    name: "account-goldner-club-slug___fi",
    path: "/fi/account/goldner-club/:slug()",
    meta: _91slug_93Sy_Q9HAZmykVIsaM4XBiKfFL5BbhArx_TcidNnY4O7kMeta || {},
    component: () => import("/app/apps/ags/pages/account/goldner-club/[slug].vue")
  },
  {
    name: "account-goldner-club-slug___fr",
    path: "/fr/account/goldner-club/:slug()",
    meta: _91slug_93Sy_Q9HAZmykVIsaM4XBiKfFL5BbhArx_TcidNnY4O7kMeta || {},
    component: () => import("/app/apps/ags/pages/account/goldner-club/[slug].vue")
  },
  {
    name: "account-goldner-club-slug___nl",
    path: "/nl/account/goldner-club/:slug()",
    meta: _91slug_93Sy_Q9HAZmykVIsaM4XBiKfFL5BbhArx_TcidNnY4O7kMeta || {},
    component: () => import("/app/apps/ags/pages/account/goldner-club/[slug].vue")
  },
  {
    name: "account-goldner-club___at",
    path: "/at/account/goldner-club",
    meta: index9EdcBJDRCIH0SFtz8DGhvhPik_kBPMA8J5Ph5iyWyWEMeta || {},
    component: () => import("/app/apps/ags/pages/account/goldner-club/index.vue")
  },
  {
    name: "account-goldner-club___be",
    path: "/be/account/goldner-club",
    meta: index9EdcBJDRCIH0SFtz8DGhvhPik_kBPMA8J5Ph5iyWyWEMeta || {},
    component: () => import("/app/apps/ags/pages/account/goldner-club/index.vue")
  },
  {
    name: "account-goldner-club___fr-be",
    path: "/fr-be/account/goldner-club",
    meta: index9EdcBJDRCIH0SFtz8DGhvhPik_kBPMA8J5Ph5iyWyWEMeta || {},
    component: () => import("/app/apps/ags/pages/account/goldner-club/index.vue")
  },
  {
    name: "account-goldner-club___ch",
    path: "/ch/account/goldner-club",
    meta: index9EdcBJDRCIH0SFtz8DGhvhPik_kBPMA8J5Ph5iyWyWEMeta || {},
    component: () => import("/app/apps/ags/pages/account/goldner-club/index.vue")
  },
  {
    name: "account-goldner-club___fr-ch",
    path: "/fr-ch/account/goldner-club",
    meta: index9EdcBJDRCIH0SFtz8DGhvhPik_kBPMA8J5Ph5iyWyWEMeta || {},
    component: () => import("/app/apps/ags/pages/account/goldner-club/index.vue")
  },
  {
    name: "account-goldner-club___de",
    path: "/de/account/goldner-club",
    meta: index9EdcBJDRCIH0SFtz8DGhvhPik_kBPMA8J5Ph5iyWyWEMeta || {},
    component: () => import("/app/apps/ags/pages/account/goldner-club/index.vue")
  },
  {
    name: "account-goldner-club___fi",
    path: "/fi/account/goldner-club",
    meta: index9EdcBJDRCIH0SFtz8DGhvhPik_kBPMA8J5Ph5iyWyWEMeta || {},
    component: () => import("/app/apps/ags/pages/account/goldner-club/index.vue")
  },
  {
    name: "account-goldner-club___fr",
    path: "/fr/account/goldner-club",
    meta: index9EdcBJDRCIH0SFtz8DGhvhPik_kBPMA8J5Ph5iyWyWEMeta || {},
    component: () => import("/app/apps/ags/pages/account/goldner-club/index.vue")
  },
  {
    name: "account-goldner-club___nl",
    path: "/nl/account/goldner-club",
    meta: index9EdcBJDRCIH0SFtz8DGhvhPik_kBPMA8J5Ph5iyWyWEMeta || {},
    component: () => import("/app/apps/ags/pages/account/goldner-club/index.vue")
  },
  {
    name: "account-orders___at",
    path: "/at/account/orders",
    meta: ordersl_GnqUJdAUltCfZ_VEfvEGii9CeGQJva_3hmVbuLRhoMeta || {},
    component: () => import("/app/layers/base/pages/account/orders.vue"),
    children: [
  {
    name: "account-orders-id___at",
    path: ":id()",
    meta: _91id_939jYdp_xLhY_reztBcR3qpsWXXQjD_vhTN04oKURkiMgMeta || {},
    component: () => import("/app/apps/ags/pages/account/orders/[id].vue")
  }
]
  },
  {
    name: "account-orders___be",
    path: "/be/account/orders",
    meta: ordersl_GnqUJdAUltCfZ_VEfvEGii9CeGQJva_3hmVbuLRhoMeta || {},
    component: () => import("/app/layers/base/pages/account/orders.vue"),
    children: [
  {
    name: "account-orders-id___be",
    path: ":id()",
    meta: _91id_939jYdp_xLhY_reztBcR3qpsWXXQjD_vhTN04oKURkiMgMeta || {},
    component: () => import("/app/apps/ags/pages/account/orders/[id].vue")
  }
]
  },
  {
    name: "account-orders___fr-be",
    path: "/fr-be/account/orders",
    meta: ordersl_GnqUJdAUltCfZ_VEfvEGii9CeGQJva_3hmVbuLRhoMeta || {},
    component: () => import("/app/layers/base/pages/account/orders.vue"),
    children: [
  {
    name: "account-orders-id___fr-be",
    path: ":id()",
    meta: _91id_939jYdp_xLhY_reztBcR3qpsWXXQjD_vhTN04oKURkiMgMeta || {},
    component: () => import("/app/apps/ags/pages/account/orders/[id].vue")
  }
]
  },
  {
    name: "account-orders___ch",
    path: "/ch/account/orders",
    meta: ordersl_GnqUJdAUltCfZ_VEfvEGii9CeGQJva_3hmVbuLRhoMeta || {},
    component: () => import("/app/layers/base/pages/account/orders.vue"),
    children: [
  {
    name: "account-orders-id___ch",
    path: ":id()",
    meta: _91id_939jYdp_xLhY_reztBcR3qpsWXXQjD_vhTN04oKURkiMgMeta || {},
    component: () => import("/app/apps/ags/pages/account/orders/[id].vue")
  }
]
  },
  {
    name: "account-orders___fr-ch",
    path: "/fr-ch/account/orders",
    meta: ordersl_GnqUJdAUltCfZ_VEfvEGii9CeGQJva_3hmVbuLRhoMeta || {},
    component: () => import("/app/layers/base/pages/account/orders.vue"),
    children: [
  {
    name: "account-orders-id___fr-ch",
    path: ":id()",
    meta: _91id_939jYdp_xLhY_reztBcR3qpsWXXQjD_vhTN04oKURkiMgMeta || {},
    component: () => import("/app/apps/ags/pages/account/orders/[id].vue")
  }
]
  },
  {
    name: "account-orders___de",
    path: "/de/account/orders",
    meta: ordersl_GnqUJdAUltCfZ_VEfvEGii9CeGQJva_3hmVbuLRhoMeta || {},
    component: () => import("/app/layers/base/pages/account/orders.vue"),
    children: [
  {
    name: "account-orders-id___de",
    path: ":id()",
    meta: _91id_939jYdp_xLhY_reztBcR3qpsWXXQjD_vhTN04oKURkiMgMeta || {},
    component: () => import("/app/apps/ags/pages/account/orders/[id].vue")
  }
]
  },
  {
    name: "account-orders___fi",
    path: "/fi/account/orders",
    meta: ordersl_GnqUJdAUltCfZ_VEfvEGii9CeGQJva_3hmVbuLRhoMeta || {},
    component: () => import("/app/layers/base/pages/account/orders.vue"),
    children: [
  {
    name: "account-orders-id___fi",
    path: ":id()",
    meta: _91id_939jYdp_xLhY_reztBcR3qpsWXXQjD_vhTN04oKURkiMgMeta || {},
    component: () => import("/app/apps/ags/pages/account/orders/[id].vue")
  }
]
  },
  {
    name: "account-orders___fr",
    path: "/fr/account/orders",
    meta: ordersl_GnqUJdAUltCfZ_VEfvEGii9CeGQJva_3hmVbuLRhoMeta || {},
    component: () => import("/app/layers/base/pages/account/orders.vue"),
    children: [
  {
    name: "account-orders-id___fr",
    path: ":id()",
    meta: _91id_939jYdp_xLhY_reztBcR3qpsWXXQjD_vhTN04oKURkiMgMeta || {},
    component: () => import("/app/apps/ags/pages/account/orders/[id].vue")
  }
]
  },
  {
    name: "account-orders___nl",
    path: "/nl/account/orders",
    meta: ordersl_GnqUJdAUltCfZ_VEfvEGii9CeGQJva_3hmVbuLRhoMeta || {},
    component: () => import("/app/layers/base/pages/account/orders.vue"),
    children: [
  {
    name: "account-orders-id___nl",
    path: ":id()",
    meta: _91id_939jYdp_xLhY_reztBcR3qpsWXXQjD_vhTN04oKURkiMgMeta || {},
    component: () => import("/app/apps/ags/pages/account/orders/[id].vue")
  }
]
  },
  {
    name: "account-user___at",
    path: "/at/account/user",
    meta: indexKaVL1h9bonjwaeLvNToDBFm1KffgBU0BihTvtcoy7LcMeta || {},
    component: () => import("/app/apps/ags/pages/account/user/index.vue")
  },
  {
    name: "account-user___be",
    path: "/be/account/user",
    meta: indexKaVL1h9bonjwaeLvNToDBFm1KffgBU0BihTvtcoy7LcMeta || {},
    component: () => import("/app/apps/ags/pages/account/user/index.vue")
  },
  {
    name: "account-user___fr-be",
    path: "/fr-be/account/user",
    meta: indexKaVL1h9bonjwaeLvNToDBFm1KffgBU0BihTvtcoy7LcMeta || {},
    component: () => import("/app/apps/ags/pages/account/user/index.vue")
  },
  {
    name: "account-user___ch",
    path: "/ch/account/user",
    meta: indexKaVL1h9bonjwaeLvNToDBFm1KffgBU0BihTvtcoy7LcMeta || {},
    component: () => import("/app/apps/ags/pages/account/user/index.vue")
  },
  {
    name: "account-user___fr-ch",
    path: "/fr-ch/account/user",
    meta: indexKaVL1h9bonjwaeLvNToDBFm1KffgBU0BihTvtcoy7LcMeta || {},
    component: () => import("/app/apps/ags/pages/account/user/index.vue")
  },
  {
    name: "account-user___de",
    path: "/de/account/user",
    meta: indexKaVL1h9bonjwaeLvNToDBFm1KffgBU0BihTvtcoy7LcMeta || {},
    component: () => import("/app/apps/ags/pages/account/user/index.vue")
  },
  {
    name: "account-user___fi",
    path: "/fi/account/user",
    meta: indexKaVL1h9bonjwaeLvNToDBFm1KffgBU0BihTvtcoy7LcMeta || {},
    component: () => import("/app/apps/ags/pages/account/user/index.vue")
  },
  {
    name: "account-user___fr",
    path: "/fr/account/user",
    meta: indexKaVL1h9bonjwaeLvNToDBFm1KffgBU0BihTvtcoy7LcMeta || {},
    component: () => import("/app/apps/ags/pages/account/user/index.vue")
  },
  {
    name: "account-user___nl",
    path: "/nl/account/user",
    meta: indexKaVL1h9bonjwaeLvNToDBFm1KffgBU0BihTvtcoy7LcMeta || {},
    component: () => import("/app/apps/ags/pages/account/user/index.vue")
  },
  {
    name: "password-reset___at",
    path: "/at/password/reset",
    meta: resetF3FXgIq9dmSGzcU0z56hHVtgd0Skqc8xyJOaRI6F8QAMeta || {},
    component: () => import("/app/layers/base/pages/password/reset.vue")
  },
  {
    name: "password-reset___be",
    path: "/be/password/reset",
    meta: resetF3FXgIq9dmSGzcU0z56hHVtgd0Skqc8xyJOaRI6F8QAMeta || {},
    component: () => import("/app/layers/base/pages/password/reset.vue")
  },
  {
    name: "password-reset___fr-be",
    path: "/fr-be/password/reset",
    meta: resetF3FXgIq9dmSGzcU0z56hHVtgd0Skqc8xyJOaRI6F8QAMeta || {},
    component: () => import("/app/layers/base/pages/password/reset.vue")
  },
  {
    name: "password-reset___ch",
    path: "/ch/password/reset",
    meta: resetF3FXgIq9dmSGzcU0z56hHVtgd0Skqc8xyJOaRI6F8QAMeta || {},
    component: () => import("/app/layers/base/pages/password/reset.vue")
  },
  {
    name: "password-reset___fr-ch",
    path: "/fr-ch/password/reset",
    meta: resetF3FXgIq9dmSGzcU0z56hHVtgd0Skqc8xyJOaRI6F8QAMeta || {},
    component: () => import("/app/layers/base/pages/password/reset.vue")
  },
  {
    name: "password-reset___de",
    path: "/de/password/reset",
    meta: resetF3FXgIq9dmSGzcU0z56hHVtgd0Skqc8xyJOaRI6F8QAMeta || {},
    component: () => import("/app/layers/base/pages/password/reset.vue")
  },
  {
    name: "password-reset___fi",
    path: "/fi/password/reset",
    meta: resetF3FXgIq9dmSGzcU0z56hHVtgd0Skqc8xyJOaRI6F8QAMeta || {},
    component: () => import("/app/layers/base/pages/password/reset.vue")
  },
  {
    name: "password-reset___fr",
    path: "/fr/password/reset",
    meta: resetF3FXgIq9dmSGzcU0z56hHVtgd0Skqc8xyJOaRI6F8QAMeta || {},
    component: () => import("/app/layers/base/pages/password/reset.vue")
  },
  {
    name: "password-reset___nl",
    path: "/nl/password/reset",
    meta: resetF3FXgIq9dmSGzcU0z56hHVtgd0Skqc8xyJOaRI6F8QAMeta || {},
    component: () => import("/app/layers/base/pages/password/reset.vue")
  },
  {
    name: "service-direct-order___at",
    path: "/at/service/direct-order",
    meta: direct_45orderg1beYY1rNJglP1s0CjWb6KZfuYc4xVmkFvgHJwasu4IMeta || {},
    component: () => import("/app/apps/ags/pages/service/direct-order.vue")
  },
  {
    name: "service-direct-order___be",
    path: "/be/service/direct-order",
    meta: direct_45orderg1beYY1rNJglP1s0CjWb6KZfuYc4xVmkFvgHJwasu4IMeta || {},
    component: () => import("/app/apps/ags/pages/service/direct-order.vue")
  },
  {
    name: "service-direct-order___fr-be",
    path: "/fr-be/service/direct-order",
    meta: direct_45orderg1beYY1rNJglP1s0CjWb6KZfuYc4xVmkFvgHJwasu4IMeta || {},
    component: () => import("/app/apps/ags/pages/service/direct-order.vue")
  },
  {
    name: "service-direct-order___ch",
    path: "/ch/service/direct-order",
    meta: direct_45orderg1beYY1rNJglP1s0CjWb6KZfuYc4xVmkFvgHJwasu4IMeta || {},
    component: () => import("/app/apps/ags/pages/service/direct-order.vue")
  },
  {
    name: "service-direct-order___fr-ch",
    path: "/fr-ch/service/direct-order",
    meta: direct_45orderg1beYY1rNJglP1s0CjWb6KZfuYc4xVmkFvgHJwasu4IMeta || {},
    component: () => import("/app/apps/ags/pages/service/direct-order.vue")
  },
  {
    name: "service-direct-order___de",
    path: "/de/service/direct-order",
    meta: direct_45orderg1beYY1rNJglP1s0CjWb6KZfuYc4xVmkFvgHJwasu4IMeta || {},
    component: () => import("/app/apps/ags/pages/service/direct-order.vue")
  },
  {
    name: "service-direct-order___fi",
    path: "/fi/service/direct-order",
    meta: direct_45orderg1beYY1rNJglP1s0CjWb6KZfuYc4xVmkFvgHJwasu4IMeta || {},
    component: () => import("/app/apps/ags/pages/service/direct-order.vue")
  },
  {
    name: "service-direct-order___fr",
    path: "/fr/service/direct-order",
    meta: direct_45orderg1beYY1rNJglP1s0CjWb6KZfuYc4xVmkFvgHJwasu4IMeta || {},
    component: () => import("/app/apps/ags/pages/service/direct-order.vue")
  },
  {
    name: "service-direct-order___nl",
    path: "/nl/service/direct-order",
    meta: direct_45orderg1beYY1rNJglP1s0CjWb6KZfuYc4xVmkFvgHJwasu4IMeta || {},
    component: () => import("/app/apps/ags/pages/service/direct-order.vue")
  },
  {
    name: "p-slug-id___at",
    path: "/at/p/:slug()/:id()",
    meta: _91id_93IUhiTzouVMkZlHDIJaUChxIRNk1ce1yi3IpFZ_Lnb0IMeta || {},
    component: () => import("/app/apps/ags/pages/p/[slug]/[id].vue")
  },
  {
    name: "p-slug-id___be",
    path: "/be/p/:slug()/:id()",
    meta: _91id_93IUhiTzouVMkZlHDIJaUChxIRNk1ce1yi3IpFZ_Lnb0IMeta || {},
    component: () => import("/app/apps/ags/pages/p/[slug]/[id].vue")
  },
  {
    name: "p-slug-id___fr-be",
    path: "/fr-be/p/:slug()/:id()",
    meta: _91id_93IUhiTzouVMkZlHDIJaUChxIRNk1ce1yi3IpFZ_Lnb0IMeta || {},
    component: () => import("/app/apps/ags/pages/p/[slug]/[id].vue")
  },
  {
    name: "p-slug-id___ch",
    path: "/ch/p/:slug()/:id()",
    meta: _91id_93IUhiTzouVMkZlHDIJaUChxIRNk1ce1yi3IpFZ_Lnb0IMeta || {},
    component: () => import("/app/apps/ags/pages/p/[slug]/[id].vue")
  },
  {
    name: "p-slug-id___fr-ch",
    path: "/fr-ch/p/:slug()/:id()",
    meta: _91id_93IUhiTzouVMkZlHDIJaUChxIRNk1ce1yi3IpFZ_Lnb0IMeta || {},
    component: () => import("/app/apps/ags/pages/p/[slug]/[id].vue")
  },
  {
    name: "p-slug-id___de",
    path: "/de/p/:slug()/:id()",
    meta: _91id_93IUhiTzouVMkZlHDIJaUChxIRNk1ce1yi3IpFZ_Lnb0IMeta || {},
    component: () => import("/app/apps/ags/pages/p/[slug]/[id].vue")
  },
  {
    name: "p-slug-id___fi",
    path: "/fi/p/:slug()/:id()",
    meta: _91id_93IUhiTzouVMkZlHDIJaUChxIRNk1ce1yi3IpFZ_Lnb0IMeta || {},
    component: () => import("/app/apps/ags/pages/p/[slug]/[id].vue")
  },
  {
    name: "p-slug-id___fr",
    path: "/fr/p/:slug()/:id()",
    meta: _91id_93IUhiTzouVMkZlHDIJaUChxIRNk1ce1yi3IpFZ_Lnb0IMeta || {},
    component: () => import("/app/apps/ags/pages/p/[slug]/[id].vue")
  },
  {
    name: "p-slug-id___nl",
    path: "/nl/p/:slug()/:id()",
    meta: _91id_93IUhiTzouVMkZlHDIJaUChxIRNk1ce1yi3IpFZ_Lnb0IMeta || {},
    component: () => import("/app/apps/ags/pages/p/[slug]/[id].vue")
  },
  {
    name: "magazine-slug___at",
    path: "/at/magazin/:slug()",
    meta: _91slug_939xVhHkLMmVk_CFfrPzQlOhhknDckMH4QemUEBByuwUsMeta || {},
    component: () => import("/app/apps/ags/pages/magazine/[slug].vue")
  },
  {
    name: "magazine-slug___be",
    path: "/be/magazine/:slug()",
    meta: _91slug_939xVhHkLMmVk_CFfrPzQlOhhknDckMH4QemUEBByuwUsMeta || {},
    component: () => import("/app/apps/ags/pages/magazine/[slug].vue")
  },
  {
    name: "magazine-slug___fr-be",
    path: "/fr-be/magazine/:slug()",
    meta: _91slug_939xVhHkLMmVk_CFfrPzQlOhhknDckMH4QemUEBByuwUsMeta || {},
    component: () => import("/app/apps/ags/pages/magazine/[slug].vue")
  },
  {
    name: "magazine-slug___ch",
    path: "/ch/magazin/:slug()",
    meta: _91slug_939xVhHkLMmVk_CFfrPzQlOhhknDckMH4QemUEBByuwUsMeta || {},
    component: () => import("/app/apps/ags/pages/magazine/[slug].vue")
  },
  {
    name: "magazine-slug___fr-ch",
    path: "/fr-ch/magazine/:slug()",
    meta: _91slug_939xVhHkLMmVk_CFfrPzQlOhhknDckMH4QemUEBByuwUsMeta || {},
    component: () => import("/app/apps/ags/pages/magazine/[slug].vue")
  },
  {
    name: "magazine-slug___de",
    path: "/de/magazin/:slug()",
    meta: _91slug_939xVhHkLMmVk_CFfrPzQlOhhknDckMH4QemUEBByuwUsMeta || {},
    component: () => import("/app/apps/ags/pages/magazine/[slug].vue")
  },
  {
    name: "magazine-slug___fi",
    path: "/fi/magazine/:slug()",
    meta: _91slug_939xVhHkLMmVk_CFfrPzQlOhhknDckMH4QemUEBByuwUsMeta || {},
    component: () => import("/app/apps/ags/pages/magazine/[slug].vue")
  },
  {
    name: "magazine-slug___fr",
    path: "/fr/magazine/:slug()",
    meta: _91slug_939xVhHkLMmVk_CFfrPzQlOhhknDckMH4QemUEBByuwUsMeta || {},
    component: () => import("/app/apps/ags/pages/magazine/[slug].vue")
  },
  {
    name: "magazine-slug___nl",
    path: "/nl/magazine/:slug()",
    meta: _91slug_939xVhHkLMmVk_CFfrPzQlOhhknDckMH4QemUEBByuwUsMeta || {},
    component: () => import("/app/apps/ags/pages/magazine/[slug].vue")
  },
  {
    name: "outfits-slug___at",
    path: "/at/outfits/:slug()",
    meta: indexOkr3k94Mnnw0me0PQYyt15kK7ioZzAbj5Z8FV3LX2CIMeta || {},
    component: () => import("/app/apps/ags/pages/outfits/[slug]/index.vue")
  },
  {
    name: "outfits-slug___be",
    path: "/be/outfits/:slug()",
    meta: indexOkr3k94Mnnw0me0PQYyt15kK7ioZzAbj5Z8FV3LX2CIMeta || {},
    component: () => import("/app/apps/ags/pages/outfits/[slug]/index.vue")
  },
  {
    name: "outfits-slug___fr-be",
    path: "/fr-be/ensembles/:slug()",
    meta: indexOkr3k94Mnnw0me0PQYyt15kK7ioZzAbj5Z8FV3LX2CIMeta || {},
    component: () => import("/app/apps/ags/pages/outfits/[slug]/index.vue")
  },
  {
    name: "outfits-slug___ch",
    path: "/ch/outfits/:slug()",
    meta: indexOkr3k94Mnnw0me0PQYyt15kK7ioZzAbj5Z8FV3LX2CIMeta || {},
    component: () => import("/app/apps/ags/pages/outfits/[slug]/index.vue")
  },
  {
    name: "outfits-slug___fr-ch",
    path: "/fr-ch/ensembles/:slug()",
    meta: indexOkr3k94Mnnw0me0PQYyt15kK7ioZzAbj5Z8FV3LX2CIMeta || {},
    component: () => import("/app/apps/ags/pages/outfits/[slug]/index.vue")
  },
  {
    name: "outfits-slug___de",
    path: "/de/outfits/:slug()",
    meta: indexOkr3k94Mnnw0me0PQYyt15kK7ioZzAbj5Z8FV3LX2CIMeta || {},
    component: () => import("/app/apps/ags/pages/outfits/[slug]/index.vue")
  },
  {
    name: "outfits-slug___fi",
    path: "/fi/asukokonaisuudet/:slug()",
    meta: indexOkr3k94Mnnw0me0PQYyt15kK7ioZzAbj5Z8FV3LX2CIMeta || {},
    component: () => import("/app/apps/ags/pages/outfits/[slug]/index.vue")
  },
  {
    name: "outfits-slug___fr",
    path: "/fr/ensembles/:slug()",
    meta: indexOkr3k94Mnnw0me0PQYyt15kK7ioZzAbj5Z8FV3LX2CIMeta || {},
    component: () => import("/app/apps/ags/pages/outfits/[slug]/index.vue")
  },
  {
    name: "outfits-slug___nl",
    path: "/nl/outfits/:slug()",
    meta: indexOkr3k94Mnnw0me0PQYyt15kK7ioZzAbj5Z8FV3LX2CIMeta || {},
    component: () => import("/app/apps/ags/pages/outfits/[slug]/index.vue")
  },
  {
    name: "c-slug___at",
    path: "/at/c/:slug(.*)*",
    meta: _91_46_46_46slug_93tgNZI1oo6suJ2uFMuxbIVv0_ZISFrlYnnUrOycf0ewwMeta || {},
    component: () => import("/app/apps/ags/pages/c/[...slug].vue")
  },
  {
    name: "c-slug___be",
    path: "/be/c/:slug(.*)*",
    meta: _91_46_46_46slug_93tgNZI1oo6suJ2uFMuxbIVv0_ZISFrlYnnUrOycf0ewwMeta || {},
    component: () => import("/app/apps/ags/pages/c/[...slug].vue")
  },
  {
    name: "c-slug___fr-be",
    path: "/fr-be/c/:slug(.*)*",
    meta: _91_46_46_46slug_93tgNZI1oo6suJ2uFMuxbIVv0_ZISFrlYnnUrOycf0ewwMeta || {},
    component: () => import("/app/apps/ags/pages/c/[...slug].vue")
  },
  {
    name: "c-slug___ch",
    path: "/ch/c/:slug(.*)*",
    meta: _91_46_46_46slug_93tgNZI1oo6suJ2uFMuxbIVv0_ZISFrlYnnUrOycf0ewwMeta || {},
    component: () => import("/app/apps/ags/pages/c/[...slug].vue")
  },
  {
    name: "c-slug___fr-ch",
    path: "/fr-ch/c/:slug(.*)*",
    meta: _91_46_46_46slug_93tgNZI1oo6suJ2uFMuxbIVv0_ZISFrlYnnUrOycf0ewwMeta || {},
    component: () => import("/app/apps/ags/pages/c/[...slug].vue")
  },
  {
    name: "c-slug___de",
    path: "/de/c/:slug(.*)*",
    meta: _91_46_46_46slug_93tgNZI1oo6suJ2uFMuxbIVv0_ZISFrlYnnUrOycf0ewwMeta || {},
    component: () => import("/app/apps/ags/pages/c/[...slug].vue")
  },
  {
    name: "c-slug___fi",
    path: "/fi/c/:slug(.*)*",
    meta: _91_46_46_46slug_93tgNZI1oo6suJ2uFMuxbIVv0_ZISFrlYnnUrOycf0ewwMeta || {},
    component: () => import("/app/apps/ags/pages/c/[...slug].vue")
  },
  {
    name: "c-slug___fr",
    path: "/fr/c/:slug(.*)*",
    meta: _91_46_46_46slug_93tgNZI1oo6suJ2uFMuxbIVv0_ZISFrlYnnUrOycf0ewwMeta || {},
    component: () => import("/app/apps/ags/pages/c/[...slug].vue")
  },
  {
    name: "c-slug___nl",
    path: "/nl/c/:slug(.*)*",
    meta: _91_46_46_46slug_93tgNZI1oo6suJ2uFMuxbIVv0_ZISFrlYnnUrOycf0ewwMeta || {},
    component: () => import("/app/apps/ags/pages/c/[...slug].vue")
  },
  {
    name: "account___at",
    path: "/at/account",
    meta: indexQlCtmYL7wBCvlSN95FL5dykt_pUUcjys3pMSl92ABTEMeta || {},
    component: () => import("/app/apps/ags/pages/account/index.vue")
  },
  {
    name: "account___be",
    path: "/be/account",
    meta: indexQlCtmYL7wBCvlSN95FL5dykt_pUUcjys3pMSl92ABTEMeta || {},
    component: () => import("/app/apps/ags/pages/account/index.vue")
  },
  {
    name: "account___fr-be",
    path: "/fr-be/account",
    meta: indexQlCtmYL7wBCvlSN95FL5dykt_pUUcjys3pMSl92ABTEMeta || {},
    component: () => import("/app/apps/ags/pages/account/index.vue")
  },
  {
    name: "account___ch",
    path: "/ch/account",
    meta: indexQlCtmYL7wBCvlSN95FL5dykt_pUUcjys3pMSl92ABTEMeta || {},
    component: () => import("/app/apps/ags/pages/account/index.vue")
  },
  {
    name: "account___fr-ch",
    path: "/fr-ch/account",
    meta: indexQlCtmYL7wBCvlSN95FL5dykt_pUUcjys3pMSl92ABTEMeta || {},
    component: () => import("/app/apps/ags/pages/account/index.vue")
  },
  {
    name: "account___de",
    path: "/de/account",
    meta: indexQlCtmYL7wBCvlSN95FL5dykt_pUUcjys3pMSl92ABTEMeta || {},
    component: () => import("/app/apps/ags/pages/account/index.vue")
  },
  {
    name: "account___fi",
    path: "/fi/account",
    meta: indexQlCtmYL7wBCvlSN95FL5dykt_pUUcjys3pMSl92ABTEMeta || {},
    component: () => import("/app/apps/ags/pages/account/index.vue")
  },
  {
    name: "account___fr",
    path: "/fr/account",
    meta: indexQlCtmYL7wBCvlSN95FL5dykt_pUUcjys3pMSl92ABTEMeta || {},
    component: () => import("/app/apps/ags/pages/account/index.vue")
  },
  {
    name: "account___nl",
    path: "/nl/account",
    meta: indexQlCtmYL7wBCvlSN95FL5dykt_pUUcjys3pMSl92ABTEMeta || {},
    component: () => import("/app/apps/ags/pages/account/index.vue")
  },
  {
    name: "basket___at",
    path: "/at/basket",
    meta: basketbSeLQ73G9IkL_0Dc1VcSNdyU8pzRNl2aw1KK1IR_fOUMeta || {},
    component: () => import("/app/apps/ags/pages/basket.vue")
  },
  {
    name: "basket___be",
    path: "/be/basket",
    meta: basketbSeLQ73G9IkL_0Dc1VcSNdyU8pzRNl2aw1KK1IR_fOUMeta || {},
    component: () => import("/app/apps/ags/pages/basket.vue")
  },
  {
    name: "basket___fr-be",
    path: "/fr-be/basket",
    meta: basketbSeLQ73G9IkL_0Dc1VcSNdyU8pzRNl2aw1KK1IR_fOUMeta || {},
    component: () => import("/app/apps/ags/pages/basket.vue")
  },
  {
    name: "basket___ch",
    path: "/ch/basket",
    meta: basketbSeLQ73G9IkL_0Dc1VcSNdyU8pzRNl2aw1KK1IR_fOUMeta || {},
    component: () => import("/app/apps/ags/pages/basket.vue")
  },
  {
    name: "basket___fr-ch",
    path: "/fr-ch/basket",
    meta: basketbSeLQ73G9IkL_0Dc1VcSNdyU8pzRNl2aw1KK1IR_fOUMeta || {},
    component: () => import("/app/apps/ags/pages/basket.vue")
  },
  {
    name: "basket___de",
    path: "/de/basket",
    meta: basketbSeLQ73G9IkL_0Dc1VcSNdyU8pzRNl2aw1KK1IR_fOUMeta || {},
    component: () => import("/app/apps/ags/pages/basket.vue")
  },
  {
    name: "basket___fi",
    path: "/fi/basket",
    meta: basketbSeLQ73G9IkL_0Dc1VcSNdyU8pzRNl2aw1KK1IR_fOUMeta || {},
    component: () => import("/app/apps/ags/pages/basket.vue")
  },
  {
    name: "basket___fr",
    path: "/fr/basket",
    meta: basketbSeLQ73G9IkL_0Dc1VcSNdyU8pzRNl2aw1KK1IR_fOUMeta || {},
    component: () => import("/app/apps/ags/pages/basket.vue")
  },
  {
    name: "basket___nl",
    path: "/nl/basket",
    meta: basketbSeLQ73G9IkL_0Dc1VcSNdyU8pzRNl2aw1KK1IR_fOUMeta || {},
    component: () => import("/app/apps/ags/pages/basket.vue")
  },
  {
    name: "checkout___at",
    path: "/at/checkout",
    meta: checkout7RWXJwXJ0p_Cyroz15Py0wiOKlVRA4nsmR9izWTRey8Meta || {},
    component: () => import("/app/apps/ags/pages/checkout.vue")
  },
  {
    name: "checkout___be",
    path: "/be/checkout",
    meta: checkout7RWXJwXJ0p_Cyroz15Py0wiOKlVRA4nsmR9izWTRey8Meta || {},
    component: () => import("/app/apps/ags/pages/checkout.vue")
  },
  {
    name: "checkout___fr-be",
    path: "/fr-be/checkout",
    meta: checkout7RWXJwXJ0p_Cyroz15Py0wiOKlVRA4nsmR9izWTRey8Meta || {},
    component: () => import("/app/apps/ags/pages/checkout.vue")
  },
  {
    name: "checkout___ch",
    path: "/ch/checkout",
    meta: checkout7RWXJwXJ0p_Cyroz15Py0wiOKlVRA4nsmR9izWTRey8Meta || {},
    component: () => import("/app/apps/ags/pages/checkout.vue")
  },
  {
    name: "checkout___fr-ch",
    path: "/fr-ch/checkout",
    meta: checkout7RWXJwXJ0p_Cyroz15Py0wiOKlVRA4nsmR9izWTRey8Meta || {},
    component: () => import("/app/apps/ags/pages/checkout.vue")
  },
  {
    name: "checkout___de",
    path: "/de/checkout",
    meta: checkout7RWXJwXJ0p_Cyroz15Py0wiOKlVRA4nsmR9izWTRey8Meta || {},
    component: () => import("/app/apps/ags/pages/checkout.vue")
  },
  {
    name: "checkout___fi",
    path: "/fi/checkout",
    meta: checkout7RWXJwXJ0p_Cyroz15Py0wiOKlVRA4nsmR9izWTRey8Meta || {},
    component: () => import("/app/apps/ags/pages/checkout.vue")
  },
  {
    name: "checkout___fr",
    path: "/fr/checkout",
    meta: checkout7RWXJwXJ0p_Cyroz15Py0wiOKlVRA4nsmR9izWTRey8Meta || {},
    component: () => import("/app/apps/ags/pages/checkout.vue")
  },
  {
    name: "checkout___nl",
    path: "/nl/checkout",
    meta: checkout7RWXJwXJ0p_Cyroz15Py0wiOKlVRA4nsmR9izWTRey8Meta || {},
    component: () => import("/app/apps/ags/pages/checkout.vue")
  },
  {
    name: "checkout_external_basket___at",
    path: "/at/checkout_external_basket",
    meta: checkout_external_basketMt4mJpjEkg33UW4shRkiLiGrf_JGosO1DQQ14alg1h4Meta || {},
    component: () => import("/app/apps/ags/pages/checkout_external_basket.vue")
  },
  {
    name: "checkout_external_basket___be",
    path: "/be/checkout_external_basket",
    meta: checkout_external_basketMt4mJpjEkg33UW4shRkiLiGrf_JGosO1DQQ14alg1h4Meta || {},
    component: () => import("/app/apps/ags/pages/checkout_external_basket.vue")
  },
  {
    name: "checkout_external_basket___fr-be",
    path: "/fr-be/checkout_external_basket",
    meta: checkout_external_basketMt4mJpjEkg33UW4shRkiLiGrf_JGosO1DQQ14alg1h4Meta || {},
    component: () => import("/app/apps/ags/pages/checkout_external_basket.vue")
  },
  {
    name: "checkout_external_basket___ch",
    path: "/ch/checkout_external_basket",
    meta: checkout_external_basketMt4mJpjEkg33UW4shRkiLiGrf_JGosO1DQQ14alg1h4Meta || {},
    component: () => import("/app/apps/ags/pages/checkout_external_basket.vue")
  },
  {
    name: "checkout_external_basket___fr-ch",
    path: "/fr-ch/checkout_external_basket",
    meta: checkout_external_basketMt4mJpjEkg33UW4shRkiLiGrf_JGosO1DQQ14alg1h4Meta || {},
    component: () => import("/app/apps/ags/pages/checkout_external_basket.vue")
  },
  {
    name: "checkout_external_basket___de",
    path: "/de/checkout_external_basket",
    meta: checkout_external_basketMt4mJpjEkg33UW4shRkiLiGrf_JGosO1DQQ14alg1h4Meta || {},
    component: () => import("/app/apps/ags/pages/checkout_external_basket.vue")
  },
  {
    name: "checkout_external_basket___fi",
    path: "/fi/checkout_external_basket",
    meta: checkout_external_basketMt4mJpjEkg33UW4shRkiLiGrf_JGosO1DQQ14alg1h4Meta || {},
    component: () => import("/app/apps/ags/pages/checkout_external_basket.vue")
  },
  {
    name: "checkout_external_basket___fr",
    path: "/fr/checkout_external_basket",
    meta: checkout_external_basketMt4mJpjEkg33UW4shRkiLiGrf_JGosO1DQQ14alg1h4Meta || {},
    component: () => import("/app/apps/ags/pages/checkout_external_basket.vue")
  },
  {
    name: "checkout_external_basket___nl",
    path: "/nl/checkout_external_basket",
    meta: checkout_external_basketMt4mJpjEkg33UW4shRkiLiGrf_JGosO1DQQ14alg1h4Meta || {},
    component: () => import("/app/apps/ags/pages/checkout_external_basket.vue")
  },
  {
    name: "magazine___at",
    path: "/at/magazin",
    meta: indexoW5Oj6WwicnJf19YMh5LGbn4f2sMGoAu9EXk6UkxlbkMeta || {},
    component: () => import("/app/apps/ags/pages/magazine/index.vue")
  },
  {
    name: "magazine___be",
    path: "/be/magazine",
    meta: indexoW5Oj6WwicnJf19YMh5LGbn4f2sMGoAu9EXk6UkxlbkMeta || {},
    component: () => import("/app/apps/ags/pages/magazine/index.vue")
  },
  {
    name: "magazine___fr-be",
    path: "/fr-be/magazine",
    meta: indexoW5Oj6WwicnJf19YMh5LGbn4f2sMGoAu9EXk6UkxlbkMeta || {},
    component: () => import("/app/apps/ags/pages/magazine/index.vue")
  },
  {
    name: "magazine___ch",
    path: "/ch/magazin",
    meta: indexoW5Oj6WwicnJf19YMh5LGbn4f2sMGoAu9EXk6UkxlbkMeta || {},
    component: () => import("/app/apps/ags/pages/magazine/index.vue")
  },
  {
    name: "magazine___fr-ch",
    path: "/fr-ch/magazine",
    meta: indexoW5Oj6WwicnJf19YMh5LGbn4f2sMGoAu9EXk6UkxlbkMeta || {},
    component: () => import("/app/apps/ags/pages/magazine/index.vue")
  },
  {
    name: "magazine___de",
    path: "/de/magazin",
    meta: indexoW5Oj6WwicnJf19YMh5LGbn4f2sMGoAu9EXk6UkxlbkMeta || {},
    component: () => import("/app/apps/ags/pages/magazine/index.vue")
  },
  {
    name: "magazine___fi",
    path: "/fi/magazine",
    meta: indexoW5Oj6WwicnJf19YMh5LGbn4f2sMGoAu9EXk6UkxlbkMeta || {},
    component: () => import("/app/apps/ags/pages/magazine/index.vue")
  },
  {
    name: "magazine___fr",
    path: "/fr/magazine",
    meta: indexoW5Oj6WwicnJf19YMh5LGbn4f2sMGoAu9EXk6UkxlbkMeta || {},
    component: () => import("/app/apps/ags/pages/magazine/index.vue")
  },
  {
    name: "magazine___nl",
    path: "/nl/magazine",
    meta: indexoW5Oj6WwicnJf19YMh5LGbn4f2sMGoAu9EXk6UkxlbkMeta || {},
    component: () => import("/app/apps/ags/pages/magazine/index.vue")
  },
  {
    name: "outfits___at",
    path: "/at/outfits",
    meta: indexPh8_GpyGxBpPb6lON_y8kQNZqfbBVragPLcB9c_A0pcMeta || {},
    component: () => import("/app/apps/ags/pages/outfits/index.vue")
  },
  {
    name: "outfits___be",
    path: "/be/outfits",
    meta: indexPh8_GpyGxBpPb6lON_y8kQNZqfbBVragPLcB9c_A0pcMeta || {},
    component: () => import("/app/apps/ags/pages/outfits/index.vue")
  },
  {
    name: "outfits___fr-be",
    path: "/fr-be/ensembles",
    meta: indexPh8_GpyGxBpPb6lON_y8kQNZqfbBVragPLcB9c_A0pcMeta || {},
    component: () => import("/app/apps/ags/pages/outfits/index.vue")
  },
  {
    name: "outfits___ch",
    path: "/ch/outfits",
    meta: indexPh8_GpyGxBpPb6lON_y8kQNZqfbBVragPLcB9c_A0pcMeta || {},
    component: () => import("/app/apps/ags/pages/outfits/index.vue")
  },
  {
    name: "outfits___fr-ch",
    path: "/fr-ch/ensembles",
    meta: indexPh8_GpyGxBpPb6lON_y8kQNZqfbBVragPLcB9c_A0pcMeta || {},
    component: () => import("/app/apps/ags/pages/outfits/index.vue")
  },
  {
    name: "outfits___de",
    path: "/de/outfits",
    meta: indexPh8_GpyGxBpPb6lON_y8kQNZqfbBVragPLcB9c_A0pcMeta || {},
    component: () => import("/app/apps/ags/pages/outfits/index.vue")
  },
  {
    name: "outfits___fi",
    path: "/fi/asukokonaisuudet",
    meta: indexPh8_GpyGxBpPb6lON_y8kQNZqfbBVragPLcB9c_A0pcMeta || {},
    component: () => import("/app/apps/ags/pages/outfits/index.vue")
  },
  {
    name: "outfits___fr",
    path: "/fr/ensembles",
    meta: indexPh8_GpyGxBpPb6lON_y8kQNZqfbBVragPLcB9c_A0pcMeta || {},
    component: () => import("/app/apps/ags/pages/outfits/index.vue")
  },
  {
    name: "outfits___nl",
    path: "/nl/outfits",
    meta: indexPh8_GpyGxBpPb6lON_y8kQNZqfbBVragPLcB9c_A0pcMeta || {},
    component: () => import("/app/apps/ags/pages/outfits/index.vue")
  },
  {
    name: "releasetestpage___at",
    path: "/at/releasetestpage",
    meta: releasetestpageOi6JLRiRXwr4Sc2sYhGwhn9oXn__0xmEQLMDKOtuJCoMeta || {},
    component: () => import("/app/layers/base/pages/releasetestpage.vue")
  },
  {
    name: "releasetestpage___be",
    path: "/be/releasetestpage",
    meta: releasetestpageOi6JLRiRXwr4Sc2sYhGwhn9oXn__0xmEQLMDKOtuJCoMeta || {},
    component: () => import("/app/layers/base/pages/releasetestpage.vue")
  },
  {
    name: "releasetestpage___fr-be",
    path: "/fr-be/releasetestpage",
    meta: releasetestpageOi6JLRiRXwr4Sc2sYhGwhn9oXn__0xmEQLMDKOtuJCoMeta || {},
    component: () => import("/app/layers/base/pages/releasetestpage.vue")
  },
  {
    name: "releasetestpage___ch",
    path: "/ch/releasetestpage",
    meta: releasetestpageOi6JLRiRXwr4Sc2sYhGwhn9oXn__0xmEQLMDKOtuJCoMeta || {},
    component: () => import("/app/layers/base/pages/releasetestpage.vue")
  },
  {
    name: "releasetestpage___fr-ch",
    path: "/fr-ch/releasetestpage",
    meta: releasetestpageOi6JLRiRXwr4Sc2sYhGwhn9oXn__0xmEQLMDKOtuJCoMeta || {},
    component: () => import("/app/layers/base/pages/releasetestpage.vue")
  },
  {
    name: "releasetestpage___de",
    path: "/de/releasetestpage",
    meta: releasetestpageOi6JLRiRXwr4Sc2sYhGwhn9oXn__0xmEQLMDKOtuJCoMeta || {},
    component: () => import("/app/layers/base/pages/releasetestpage.vue")
  },
  {
    name: "releasetestpage___fi",
    path: "/fi/releasetestpage",
    meta: releasetestpageOi6JLRiRXwr4Sc2sYhGwhn9oXn__0xmEQLMDKOtuJCoMeta || {},
    component: () => import("/app/layers/base/pages/releasetestpage.vue")
  },
  {
    name: "releasetestpage___fr",
    path: "/fr/releasetestpage",
    meta: releasetestpageOi6JLRiRXwr4Sc2sYhGwhn9oXn__0xmEQLMDKOtuJCoMeta || {},
    component: () => import("/app/layers/base/pages/releasetestpage.vue")
  },
  {
    name: "releasetestpage___nl",
    path: "/nl/releasetestpage",
    meta: releasetestpageOi6JLRiRXwr4Sc2sYhGwhn9oXn__0xmEQLMDKOtuJCoMeta || {},
    component: () => import("/app/layers/base/pages/releasetestpage.vue")
  },
  {
    name: "search___at",
    path: "/at/search",
    meta: searchgrDs2z36YLi1H_UfcBJ0py0MIwamnbKvG_ADCvWVutEMeta || {},
    component: () => import("/app/layers/base/pages/search.vue")
  },
  {
    name: "search___be",
    path: "/be/search",
    meta: searchgrDs2z36YLi1H_UfcBJ0py0MIwamnbKvG_ADCvWVutEMeta || {},
    component: () => import("/app/layers/base/pages/search.vue")
  },
  {
    name: "search___fr-be",
    path: "/fr-be/search",
    meta: searchgrDs2z36YLi1H_UfcBJ0py0MIwamnbKvG_ADCvWVutEMeta || {},
    component: () => import("/app/layers/base/pages/search.vue")
  },
  {
    name: "search___ch",
    path: "/ch/search",
    meta: searchgrDs2z36YLi1H_UfcBJ0py0MIwamnbKvG_ADCvWVutEMeta || {},
    component: () => import("/app/layers/base/pages/search.vue")
  },
  {
    name: "search___fr-ch",
    path: "/fr-ch/search",
    meta: searchgrDs2z36YLi1H_UfcBJ0py0MIwamnbKvG_ADCvWVutEMeta || {},
    component: () => import("/app/layers/base/pages/search.vue")
  },
  {
    name: "search___de",
    path: "/de/search",
    meta: searchgrDs2z36YLi1H_UfcBJ0py0MIwamnbKvG_ADCvWVutEMeta || {},
    component: () => import("/app/layers/base/pages/search.vue")
  },
  {
    name: "search___fi",
    path: "/fi/search",
    meta: searchgrDs2z36YLi1H_UfcBJ0py0MIwamnbKvG_ADCvWVutEMeta || {},
    component: () => import("/app/layers/base/pages/search.vue")
  },
  {
    name: "search___fr",
    path: "/fr/search",
    meta: searchgrDs2z36YLi1H_UfcBJ0py0MIwamnbKvG_ADCvWVutEMeta || {},
    component: () => import("/app/layers/base/pages/search.vue")
  },
  {
    name: "search___nl",
    path: "/nl/search",
    meta: searchgrDs2z36YLi1H_UfcBJ0py0MIwamnbKvG_ADCvWVutEMeta || {},
    component: () => import("/app/layers/base/pages/search.vue")
  },
  {
    name: "signin___at",
    path: "/at/signin",
    meta: signinEtLygm6Rb3c1bkLo7W4ewpawO3u73UUXxI3mvwQPxGgMeta || {},
    component: () => import("/app/apps/ags/pages/signin.vue")
  },
  {
    name: "signin___be",
    path: "/be/signin",
    meta: signinEtLygm6Rb3c1bkLo7W4ewpawO3u73UUXxI3mvwQPxGgMeta || {},
    component: () => import("/app/apps/ags/pages/signin.vue")
  },
  {
    name: "signin___fr-be",
    path: "/fr-be/signin",
    meta: signinEtLygm6Rb3c1bkLo7W4ewpawO3u73UUXxI3mvwQPxGgMeta || {},
    component: () => import("/app/apps/ags/pages/signin.vue")
  },
  {
    name: "signin___ch",
    path: "/ch/signin",
    meta: signinEtLygm6Rb3c1bkLo7W4ewpawO3u73UUXxI3mvwQPxGgMeta || {},
    component: () => import("/app/apps/ags/pages/signin.vue")
  },
  {
    name: "signin___fr-ch",
    path: "/fr-ch/signin",
    meta: signinEtLygm6Rb3c1bkLo7W4ewpawO3u73UUXxI3mvwQPxGgMeta || {},
    component: () => import("/app/apps/ags/pages/signin.vue")
  },
  {
    name: "signin___de",
    path: "/de/signin",
    meta: signinEtLygm6Rb3c1bkLo7W4ewpawO3u73UUXxI3mvwQPxGgMeta || {},
    component: () => import("/app/apps/ags/pages/signin.vue")
  },
  {
    name: "signin___fi",
    path: "/fi/signin",
    meta: signinEtLygm6Rb3c1bkLo7W4ewpawO3u73UUXxI3mvwQPxGgMeta || {},
    component: () => import("/app/apps/ags/pages/signin.vue")
  },
  {
    name: "signin___fr",
    path: "/fr/signin",
    meta: signinEtLygm6Rb3c1bkLo7W4ewpawO3u73UUXxI3mvwQPxGgMeta || {},
    component: () => import("/app/apps/ags/pages/signin.vue")
  },
  {
    name: "signin___nl",
    path: "/nl/signin",
    meta: signinEtLygm6Rb3c1bkLo7W4ewpawO3u73UUXxI3mvwQPxGgMeta || {},
    component: () => import("/app/apps/ags/pages/signin.vue")
  },
  {
    name: "success___at",
    path: "/at/success",
    meta: success7jqWc3oqAw0_5XjEfcI71MDbnriAcexCcDpEp1NOJI4Meta || {},
    component: () => import("/app/apps/ags/pages/success.vue")
  },
  {
    name: "success___be",
    path: "/be/success",
    meta: success7jqWc3oqAw0_5XjEfcI71MDbnriAcexCcDpEp1NOJI4Meta || {},
    component: () => import("/app/apps/ags/pages/success.vue")
  },
  {
    name: "success___fr-be",
    path: "/fr-be/success",
    meta: success7jqWc3oqAw0_5XjEfcI71MDbnriAcexCcDpEp1NOJI4Meta || {},
    component: () => import("/app/apps/ags/pages/success.vue")
  },
  {
    name: "success___ch",
    path: "/ch/success",
    meta: success7jqWc3oqAw0_5XjEfcI71MDbnriAcexCcDpEp1NOJI4Meta || {},
    component: () => import("/app/apps/ags/pages/success.vue")
  },
  {
    name: "success___fr-ch",
    path: "/fr-ch/success",
    meta: success7jqWc3oqAw0_5XjEfcI71MDbnriAcexCcDpEp1NOJI4Meta || {},
    component: () => import("/app/apps/ags/pages/success.vue")
  },
  {
    name: "success___de",
    path: "/de/success",
    meta: success7jqWc3oqAw0_5XjEfcI71MDbnriAcexCcDpEp1NOJI4Meta || {},
    component: () => import("/app/apps/ags/pages/success.vue")
  },
  {
    name: "success___fi",
    path: "/fi/success",
    meta: success7jqWc3oqAw0_5XjEfcI71MDbnriAcexCcDpEp1NOJI4Meta || {},
    component: () => import("/app/apps/ags/pages/success.vue")
  },
  {
    name: "success___fr",
    path: "/fr/success",
    meta: success7jqWc3oqAw0_5XjEfcI71MDbnriAcexCcDpEp1NOJI4Meta || {},
    component: () => import("/app/apps/ags/pages/success.vue")
  },
  {
    name: "success___nl",
    path: "/nl/success",
    meta: success7jqWc3oqAw0_5XjEfcI71MDbnriAcexCcDpEp1NOJI4Meta || {},
    component: () => import("/app/apps/ags/pages/success.vue")
  },
  {
    name: "wishlist___at",
    path: "/at/wishlist",
    meta: wishlistSzfUTnu0k4MxcGTI4J3d_arVQSssnNQiMz6RmapZBmgMeta || {},
    component: () => import("/app/apps/ags/pages/wishlist.vue")
  },
  {
    name: "wishlist___be",
    path: "/be/wishlist",
    meta: wishlistSzfUTnu0k4MxcGTI4J3d_arVQSssnNQiMz6RmapZBmgMeta || {},
    component: () => import("/app/apps/ags/pages/wishlist.vue")
  },
  {
    name: "wishlist___fr-be",
    path: "/fr-be/wishlist",
    meta: wishlistSzfUTnu0k4MxcGTI4J3d_arVQSssnNQiMz6RmapZBmgMeta || {},
    component: () => import("/app/apps/ags/pages/wishlist.vue")
  },
  {
    name: "wishlist___ch",
    path: "/ch/wishlist",
    meta: wishlistSzfUTnu0k4MxcGTI4J3d_arVQSssnNQiMz6RmapZBmgMeta || {},
    component: () => import("/app/apps/ags/pages/wishlist.vue")
  },
  {
    name: "wishlist___fr-ch",
    path: "/fr-ch/wishlist",
    meta: wishlistSzfUTnu0k4MxcGTI4J3d_arVQSssnNQiMz6RmapZBmgMeta || {},
    component: () => import("/app/apps/ags/pages/wishlist.vue")
  },
  {
    name: "wishlist___de",
    path: "/de/wishlist",
    meta: wishlistSzfUTnu0k4MxcGTI4J3d_arVQSssnNQiMz6RmapZBmgMeta || {},
    component: () => import("/app/apps/ags/pages/wishlist.vue")
  },
  {
    name: "wishlist___fi",
    path: "/fi/wishlist",
    meta: wishlistSzfUTnu0k4MxcGTI4J3d_arVQSssnNQiMz6RmapZBmgMeta || {},
    component: () => import("/app/apps/ags/pages/wishlist.vue")
  },
  {
    name: "wishlist___fr",
    path: "/fr/wishlist",
    meta: wishlistSzfUTnu0k4MxcGTI4J3d_arVQSssnNQiMz6RmapZBmgMeta || {},
    component: () => import("/app/apps/ags/pages/wishlist.vue")
  },
  {
    name: "wishlist___nl",
    path: "/nl/wishlist",
    meta: wishlistSzfUTnu0k4MxcGTI4J3d_arVQSssnNQiMz6RmapZBmgMeta || {},
    component: () => import("/app/apps/ags/pages/wishlist.vue")
  },
  {
    name: "slug___at",
    path: "/at/:slug(.*)*",
    meta: _91_46_46_46slug_93mMk1vWJ1XP6Z0IPjaNqnTvt6VhMchCi5GqoSNwXnZboMeta || {},
    component: () => import("/app/layers/base/pages/[...slug].vue")
  },
  {
    name: "slug___be",
    path: "/be/:slug(.*)*",
    meta: _91_46_46_46slug_93mMk1vWJ1XP6Z0IPjaNqnTvt6VhMchCi5GqoSNwXnZboMeta || {},
    component: () => import("/app/layers/base/pages/[...slug].vue")
  },
  {
    name: "slug___fr-be",
    path: "/fr-be/:slug(.*)*",
    meta: _91_46_46_46slug_93mMk1vWJ1XP6Z0IPjaNqnTvt6VhMchCi5GqoSNwXnZboMeta || {},
    component: () => import("/app/layers/base/pages/[...slug].vue")
  },
  {
    name: "slug___ch",
    path: "/ch/:slug(.*)*",
    meta: _91_46_46_46slug_93mMk1vWJ1XP6Z0IPjaNqnTvt6VhMchCi5GqoSNwXnZboMeta || {},
    component: () => import("/app/layers/base/pages/[...slug].vue")
  },
  {
    name: "slug___fr-ch",
    path: "/fr-ch/:slug(.*)*",
    meta: _91_46_46_46slug_93mMk1vWJ1XP6Z0IPjaNqnTvt6VhMchCi5GqoSNwXnZboMeta || {},
    component: () => import("/app/layers/base/pages/[...slug].vue")
  },
  {
    name: "slug___de",
    path: "/de/:slug(.*)*",
    meta: _91_46_46_46slug_93mMk1vWJ1XP6Z0IPjaNqnTvt6VhMchCi5GqoSNwXnZboMeta || {},
    component: () => import("/app/layers/base/pages/[...slug].vue")
  },
  {
    name: "slug___fi",
    path: "/fi/:slug(.*)*",
    meta: _91_46_46_46slug_93mMk1vWJ1XP6Z0IPjaNqnTvt6VhMchCi5GqoSNwXnZboMeta || {},
    component: () => import("/app/layers/base/pages/[...slug].vue")
  },
  {
    name: "slug___fr",
    path: "/fr/:slug(.*)*",
    meta: _91_46_46_46slug_93mMk1vWJ1XP6Z0IPjaNqnTvt6VhMchCi5GqoSNwXnZboMeta || {},
    component: () => import("/app/layers/base/pages/[...slug].vue")
  },
  {
    name: "slug___nl",
    path: "/nl/:slug(.*)*",
    meta: _91_46_46_46slug_93mMk1vWJ1XP6Z0IPjaNqnTvt6VhMchCi5GqoSNwXnZboMeta || {},
    component: () => import("/app/layers/base/pages/[...slug].vue")
  },
  {
    name: "index___at",
    path: "/at",
    meta: indexdbgzvN1efdLFSqI8oLN9Xus7oCDQ8dzI163ALg8gWJAMeta || {},
    component: () => import("/app/apps/ags/pages/index.vue")
  },
  {
    name: "index___be",
    path: "/be",
    meta: indexdbgzvN1efdLFSqI8oLN9Xus7oCDQ8dzI163ALg8gWJAMeta || {},
    component: () => import("/app/apps/ags/pages/index.vue")
  },
  {
    name: "index___fr-be",
    path: "/fr-be",
    meta: indexdbgzvN1efdLFSqI8oLN9Xus7oCDQ8dzI163ALg8gWJAMeta || {},
    component: () => import("/app/apps/ags/pages/index.vue")
  },
  {
    name: "index___ch",
    path: "/ch",
    meta: indexdbgzvN1efdLFSqI8oLN9Xus7oCDQ8dzI163ALg8gWJAMeta || {},
    component: () => import("/app/apps/ags/pages/index.vue")
  },
  {
    name: "index___fr-ch",
    path: "/fr-ch",
    meta: indexdbgzvN1efdLFSqI8oLN9Xus7oCDQ8dzI163ALg8gWJAMeta || {},
    component: () => import("/app/apps/ags/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: indexdbgzvN1efdLFSqI8oLN9Xus7oCDQ8dzI163ALg8gWJAMeta || {},
    component: () => import("/app/apps/ags/pages/index.vue")
  },
  {
    name: "index___fi",
    path: "/fi",
    meta: indexdbgzvN1efdLFSqI8oLN9Xus7oCDQ8dzI163ALg8gWJAMeta || {},
    component: () => import("/app/apps/ags/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: indexdbgzvN1efdLFSqI8oLN9Xus7oCDQ8dzI163ALg8gWJAMeta || {},
    component: () => import("/app/apps/ags/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    meta: indexdbgzvN1efdLFSqI8oLN9Xus7oCDQ8dzI163ALg8gWJAMeta || {},
    component: () => import("/app/apps/ags/pages/index.vue")
  }
]